import { action } from 'typesafe-actions';
import {
  CLEAR_CURRENT_MATCH_BETS,
  GET_BETS_BY_MATCH_0_BETS,
  GET_BETS_BY_MATCH_FAILURE,
  GET_BETS_BY_MATCH_REQUEST,
  GET_BETS_BY_MATCH_SUCCESS,
  REMOVE_SEARCH,
  SEARCH_MATCHES_FAILURE,
  SEARCH_MATCHES_REQUEST,
  SEARCH_MATCHES_SUCCESS,
} from '../../constants/matches';
import { Match } from '../../types/Matches';

export const searchMatchesRequestAction = (search: string) =>
  action(SEARCH_MATCHES_REQUEST, search);

export const searchMatchesSuccessAction = (data: any) =>
  action(SEARCH_MATCHES_SUCCESS, data);

export const searchMatchesFailureAction = (e: any) =>
  action(SEARCH_MATCHES_FAILURE, e);

export const removeSearch = () => action(REMOVE_SEARCH);

export const getBetsByMatchFailureAction = (e: any) =>
  action(GET_BETS_BY_MATCH_FAILURE, e);

export const getBetsByMatchRequestAction = (id: string) =>
  action(GET_BETS_BY_MATCH_REQUEST, id);

export const getBetsByMatchSuccessAction = (data: Match[]) =>
  action(GET_BETS_BY_MATCH_SUCCESS, data);

export const getBetsByMatch0BetsAction = () => action(GET_BETS_BY_MATCH_0_BETS);

export const clearCurrentMatchBets = () => action(CLEAR_CURRENT_MATCH_BETS);

export const matchesActions = {
  searchMatchesRequestAction,
  searchMatchesSuccessAction,
  searchMatchesFailureAction,
  removeSearch,
  getBetsByMatchFailureAction,
  getBetsByMatchSuccessAction,
  getBetsByMatchRequestAction,
  clearCurrentMatchBets,
  getBetsByMatch0BetsAction,
};
